import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"

const batchPaymentAdapter = createEntityAdapter()
export const initialState = batchPaymentAdapter.getInitialState({
  fetchStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
})

export const batchPaymentSlice = createSlice({
  name: "batch-payment",
  initialState,
  reducers: {},
})

export const selectFetchStatus = (state: RootState) =>
  state.features.batch_payment.fetchStatus

export default batchPaymentSlice.reducer
